export var SymbolTypes = {
  index: 'index',
  stock: 'stock'
};